"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "./ui/button";
import { CircleCheckBig } from "lucide-react";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";
import { useCurrencyPrices } from "@/hooks/useCurrencyPrices";
export default function PricingCard(t0) {
  const $ = _c(64);
  const {
    user,
    className
  } = t0;
  const t = useTranslations("PricingCard");
  const currencyPrices = useCurrencyPrices();
  const t1 = `drop-shadow-xl ${className}`;
  let t2;
  if ($[0] !== currencyPrices?.basicPrice || $[1] !== t) {
    t2 = currencyPrices?.basicPrice ?? t("price");
    $[0] = currencyPrices?.basicPrice;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="font-bold text-3xl">{t2} {" "}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("pricePostfix");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span>{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <p className="text-center">{t3}{t5}</p>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("title");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <p className="text-center text-xl">{t7} </p>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t || $[17] !== user) {
    t9 = user ? <Button className="min-w-32 mx-auto my-4" asChild={true}><Link href="/home">{t("mcta")}</Link></Button> : <Button className="min-w-32 mx-auto my-4" asChild={true}><Link href="/login" prefetch={true}>{t("mcta")}</Link></Button>;
    $[16] = t;
    $[17] = user;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CircleCheckBig className="w-5 h-5 text-primary flex-none" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("point1");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li className="flex gap-2">{t10}<span className="">{t11}</span></li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CircleCheckBig className="w-5 h-5 text-primary flex-none" />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t("point2");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14) {
    t15 = <li className="flex gap-2">{t13}<span className="">{t14}</span></li>;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <CircleCheckBig className="w-5 h-5 text-primary flex-none" />;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t("point4");
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = <li className="flex gap-2">{t16}<span className="">{t17}</span></li>;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <CircleCheckBig className="w-5 h-5 text-primary flex-none" />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t) {
    t20 = t("point5");
    $[35] = t;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t20) {
    t21 = <li className="flex gap-2">{t19}<span className="">{t20}</span></li>;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <CircleCheckBig className="w-5 h-5 text-primary flex-none" />;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t) {
    t23 = t("point6");
    $[40] = t;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t23) {
    t24 = <li className="flex gap-2">{t22}<span className="">{t23}</span></li>;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <CircleCheckBig className="w-5 h-5 text-primary flex-none" />;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t) {
    t26 = t("point7");
    $[45] = t;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t26) {
    t27 = <li className="flex gap-2">{t25}<span className="">{t26}</span></li>;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t12 || $[50] !== t15 || $[51] !== t18 || $[52] !== t21 || $[53] !== t24 || $[54] !== t27) {
    t28 = <ul className="flex flex-col gap-3">{t12}{t15}{t18}{t21}{t24}{t27}</ul>;
    $[49] = t12;
    $[50] = t15;
    $[51] = t18;
    $[52] = t21;
    $[53] = t24;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t28 || $[57] !== t6 || $[58] !== t8 || $[59] !== t9) {
    t29 = <CardContent className="p-8"><div className="flex flex-col gap-4 px-10 mt-10">{t6}{t8}{t9}{t28}</div></CardContent>;
    $[56] = t28;
    $[57] = t6;
    $[58] = t8;
    $[59] = t9;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t1 || $[62] !== t29) {
    t30 = <Card className={t1} id="pricing">{t29}</Card>;
    $[61] = t1;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  return t30;
}